import Exim from 'exim';
import Api from 'tm3-core/api';
import lazy from './lazy-loader';

export default Exim.createStore({
  actions: ['load', 'refresh'],

  initial: {
    locations: []
  },

  load() {
    return lazy('/api/locations/all').then((res) => {
      return this.set({
        locations: res.body.results
      });
    });
  },

  refresh() {
    return Api.get('/api/locations/all').then((res) => {
      return this.set({
        locations: res.body.results
      });
    });
  }
});
